export const environment = {

  // backEndApiURL: 'http://localhost:8005/api/',
  // backEndPublishURL: 'http://localhost:8005/api/',
  backEndApiURL: 'https://ilis-gateway.dongthap.gov.vn/sharing/api/',
  backEndPublishURL: 'https://ilis-gateway.dongthap.gov.vn/sharing/api/',
  mapURL: 'https://ilis-gateway.vnpt.vn/gisHCNV/wms',
  production: false,
  authenApiUrl: 'https://ilis-sso.dongthap.gov.vn/',
  apiGatewayUrl: 'https://ilis-gateway.dongthap.gov.vn/admin/',
  isUsingVnConnect: false,
  minIoURL: 'https://ilis-storage.dongthap.gov.vn/vnptcms/',
  apiUrl: 'https://ilis-gateway.dongthap.gov.vn/sharing'
};

